/**
 * v-keyboard-button: lets keyboard users reach and press an <a class="btn"> that has no href.
 *
 * The form's Next, Skip and Submit buttons, and the SMS step's buttons, are links without an href,
 * so Tab skipped them and keyboard-only applicants could not get past a step. This gives them what
 * a <button> has: a place in the Tab order, the button role for screen readers, and Enter/Space to
 * press. Pressing goes through click(), so it runs the link's own @click with all its guards
 * (reCAPTCHA, a submit already in flight, a request already out).
 *
 * They stay links rather than becoming <button>s so the per-brand GTM containers, which we can't
 * see from here, keep matching whatever element they may target.
 */

function pressOnEnterOrSpace(event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
        return;
    }
    // Space would scroll the page, Enter could reach a form
    event.preventDefault();
    event.currentTarget.click();
}

export const vKeyboardButton = {
    mounted(el) {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) {
            el.setAttribute('tabindex', '0');
        }
        el.addEventListener('keydown', pressOnEnterOrSpace);
    },
    beforeUnmount(el) {
        el.removeEventListener('keydown', pressOnEnterOrSpace);
    },
};
